import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

/**
 * @FocusableHeader returns an h1 component that gets focused on when mounted to the DOM.
 * This component helps to improve the user experience for screen reader users.
 * There should only be one instance of this component per page and on the DOM.
 * https://www.upyoura11y.com/handling-focus
 **/

const FocusableHeader = ({ children, ...props }) => {
    const headingRef = useRef(null);

    useEffect(() => {
        headingRef.current.focus();
    }, []);

    return (
        <h1 ref={headingRef} tabIndex="-1" {...props}>
            {children}
        </h1>
    );
};

FocusableHeader.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
};

export default FocusableHeader;
